import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { RecSearchService } from '../../rec-search-service';
//import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Utility } from './../../../shared/viewmodels/UtilityObj';
import { DatePipe } from '@angular/common'
import { Router } from '@angular/router'
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';


@Component({
  selector: 'app-rec-name-search-header',
  providers: [RecSearchService, DatePipe],
  templateUrl: './rec-name-search-header.component.html',
  styleUrls: ['./rec-name-search-header.component.css']
})

//@Injectable()
export class RecNameSearchHeaderComponent implements OnInit, OnDestroy {

  //recs: Observable<Utility[]>;
  recs: any;
  @Input() recordCount: number;
  @Input() filteredRecordCount: number;
  @Input() isNewTab: boolean;
  towns: string[] = [];
  types: string[] = [];
  latestRecording: string;

  constructor(private router: Router, private store: Store<AppState>, public nav: NavMenuService,
    private service: RecSearchService, private datepipe: DatePipe) {
    //this.recs = store.select('rec');
    store.select(getRegSearchState).subscribe(data => {
      this.recs = data;

      if (this.recs.city.citytowns.length > 0) {
        for (let city of this.recs.city.citytowns[0].citytowns) {
          if (city.isChecked)
            this.towns.push(city.townName);
        }
      }

      if (this.recs.doct.doct.length > 0) {
        for (let type of this.recs.doct.doct[0].doctypes) {
          if (type.isChecked)
            this.types.push(type.docName);
        }
      }
      console.log('hdr - ' + this.towns + ' ' + this.types);
    });
  }

  back(url) {

    if (this.isNewTab) {

      window.opener = 'Self';
      window.open('', '_parent', '');
      window.close();
    }
    else {
      try {
        this.service.logInfo('Clicked back button');
        this.nav.show();
        if (localStorage.getItem('recNameSearchResults') !== null) {
          console.log('remove from localStorage');
          localStorage.removeItem('recNameSearchResults');
        }
        this.router.navigate([url]);
      }
      catch (error) {
        this.service.logError(error);
      }
    }
  }

  ngOnInit() {
    this.service.getLatestRecording().subscribe(data => {
      this.latestRecording = 'Index Search available from 1/1/1962 through ' + this.datepipe.transform(data.recDate, 'medium') + ' - Book ' + data.primaryID + ' Page ' + data.secondaryID;
    });
  }

  ngOnDestroy() {
    console.log('============================RecNameHeader OnDestroy Fired');
    this.nav.show();
  }

}
